import React from 'react';
import styled from 'styled-components';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';


const EsReqConfirmInfoBlock = styled.div`
    .title {
        font-size: 16px;
        font-weight: 500;
        color: #fc1c67;
    }

    .container {
        padding: 20px 18px 20px 20px;
        border-radius: 4px;
        background-color: #f4f4f4;

        font-size: 12px;
        line-height: 1.83;
        text-align: left;
        color: #333333;

        .sub-text {
            font-size: 12px;
            font-weight: normal;
            margin-top: 4px;
            color: #666666;
        }

        .text-margin {
            margin-bottom: 8px;
        }
    }
    
`;

const EsReqConfirmInfo = ({ detailInfo }) => {


    const getSuspendMsg = () => {

        if (detailInfo.masterinfo.es_notice_msg !== null
          && detailInfo.masterinfo.es_notice_msg !== "") {
            return (
              <div className="text-margin">
                  <div className="">*{detailInfo.masterinfo.es_notice_label}</div>
                  <div className="sub-text">&nbsp;-{detailInfo.masterinfo.es_notice_msg}</div>
              </div>
            );
        }
    }

    const getLadderMsg = () => {
        if (detailInfo.masterinfo.is_ladder_car !== null
          && detailInfo.masterinfo.is_ladder_car === 1) {
            return <div className="text-margin">* 사다리차 이용 요금은 별도로 진행 합니다.</div>;
        }
    }


    if(detailInfo === null || detailInfo === undefined) {
        return <div/>
    }

    return (
        <EsReqConfirmInfoBlock>
            <div className="title margin_t-30 margin_b-10">필수 확인 사항</div>
            <div className="container">
                {detailInfo&&getSuspendMsg()}
                {detailInfo&&getLadderMsg()}
                <div className="">* 배송정보, 반품/교환/AS 안내는 각 상품상세를 참조바랍니다.</div>
            </div>
        </EsReqConfirmInfoBlock>
    );
};

export default EsReqConfirmInfo;
